import { Button, Loader, VText } from '@vake/ui-kit';
import { FC, ReactNode } from 'react';
import { useAuth } from '../../../auth/AuthProvider';
import { useIsUser, useSendToMattermost } from '../../../requests/reports';

type Props = {
    textOnButton: string;
    iconOnButton: ReactNode;
    textToSend: string;
    successMessage: string;
};
export const SendToMattermost: FC<Props> = ({ textOnButton, iconOnButton, textToSend, successMessage }) => {
    const { token } = useAuth();
    const { data: isUser } = useIsUser(token);
    const { mutateAsync, isLoading, isSuccess, isError } = useSendToMattermost();
    const handleClick = async () => {
        await mutateAsync(textToSend);
    };
    if (!isUser) {
        return <></>;
    }
    if (isError) {
        <VText>Something went wrong</VText>;
    }
    if (isLoading) {
        return (
            <div className="flex justify-center">
                <Loader size={16} />
            </div>
        );
    }
    if (isSuccess) {
        return <VText>{successMessage}</VText>;
    }
    return <Button text={textOnButton} iconAfter={iconOnButton} onClick={handleClick} />;
};
